const Wiki = (props) => (
  
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 0C17.8308 0.0135938 15.4748 0.45 13.77 1.20422C12.4978 1.76672 12 2.19234 12 3.63422V18.75C13.9486 16.9922 15.6778 16.5 22.5 16.5V0H21ZM1.5 0C4.66922 0.0135938 7.02516 0.45 8.73 1.20422C10.0022 1.76672 10.5 2.19234 10.5 3.63422V18.75C8.55141 16.9922 6.82219 16.5 0 16.5V0H1.5Z"
      fill={props.color || "#5B7B82"}
    />
  </svg>
);

export default Wiki;
